var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0557 12.6293V12.5859C15.0466 12.6006 15.037 12.6152 15.0273 12.6293H15.0557Z",
    fill: "#2E4455"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.93 0H2.06835C0.926252 0 0 0.898468 0 2.00579V25.9948C0 27.1015 0.926252 28 2.06835 28H25.93C27.0737 28 28 27.101 28 25.9948V2.00579C28 0.897905 27.0732 0 25.93 0ZM8.48696 23.4395H4.25793V10.7963H8.48696V23.4395ZM6.37273 9.06912H6.3444C4.92585 9.06912 4.00809 8.09803 4.00809 6.88488C4.00809 5.6447 4.95417 4.70063 6.40049 4.70063C7.84736 4.70063 8.73736 5.6447 8.76569 6.88488C8.76569 8.09803 7.8468 9.06912 6.37273 9.06912ZM23.737 23.4395H19.5079V16.674C19.5079 14.975 18.8961 13.8154 17.3659 13.8154C16.1978 13.8154 15.5021 14.5973 15.1956 15.3528C15.084 15.6224 15.0568 15.9996 15.0568 16.3779V23.439H10.8278C10.8278 23.439 10.8833 11.9807 10.8278 10.7957H15.0568V12.5853C15.6188 11.724 16.6238 10.4973 18.8689 10.4973C21.6511 10.4973 23.7375 12.305 23.7375 16.1887L23.737 23.4395Z",
    fill: "#2E4455"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSvg);
export default __webpack_public_path__ + "static/media/linkedinSvg.a5ff5aa5b8a48c6f48bc50941c15a56c.svg";
export { ForwardRef as ReactComponent };